import { colorTransitionDuration , colorTransitionTimingFunction } from './animation';
import remCalc from './utilities';
import colors from './colors';
import mq from './breakpoints';

const buttonBorderRadius = remCalc(4);

export const button = () => `
  padding: ${remCalc(4)} ${remCalc(6)};
  font-weight: 700;
  text-transform: uppercase;
  vertical-align: middle;
  color: ${colors.coreColor2};
  border-radius: ${buttonBorderRadius};
  display: inline-block;
  text-align: center;
  font-size: ${remCalc(16)};
  cursor: pointer; /* for spans */
  transition-property: color, background-color, border-color;
  transition-duration: ${colorTransitionDuration};
  transition-timing-function: ${colorTransitionTimingFunction};
  
  ${mq.large(`
    padding: ${remCalc(8)} ${remCalc(10)};
  `)}
`;

export const borderButton = () => `
  ${button()}
  padding: ${remCalc(2)} ${remCalc(4)};
  border-width: ${remCalc(2)};
  border-style: solid;
  
  ${mq.large(`
    padding: ${remCalc(6)} ${remCalc(8)};
  `)}
`;

export const outlineButton = () => `
  ${borderButton()}
  border-color: ${colors.coreColor2};

  &:hover, &.active {
    color: ${colors.accent};
    border-color: ${colors.accent}
    ;
  }
`;

export const ctaButton = () => `
  ${button()}
  border-color: ${colors.highlight};
  background-color: ${colors.highlight};
  color: ${colors.coreColor2} !important;
  
  &:hover, &.active {
     background-color: ${colors.highlightHover};
     border-color: ${colors.highlightHover};
  }
`;